import { useQuery } from '@apollo/client';
import { useCallback, useEffect, useState } from 'react';
import { graphql } from '../gql';
import { convergeLogger } from '@converge/config';

export const HEALTH_CHECK_QUERY = graphql(`
  query healthCheck {
    healthCheck {
      message
    }
  }
`);

export function useHealthCheckQuery() {
  const {
    data: healthCheck,
    loading: healthCheckIsLoading,
    error: healthCheckError,
    refetch,
    called: healthCheckCalled,
  } = useQuery(HEALTH_CHECK_QUERY, {
    notifyOnNetworkStatusChange: true,
  });

  const [healthCheckIsRetrying, setHealthCheckIsRetrying] =
    useState<boolean>(false);

  const retryHealthCheck = useCallback(async () => {
    setHealthCheckIsRetrying(true);
    try {
      await refetch();
    } finally {
      setHealthCheckIsRetrying(false);
    }
  }, [refetch]);

  useEffect(() => {
    if (healthCheckError) {
      convergeLogger.error('The Converge API is down:');
      convergeLogger.error(healthCheckError);
    }
  }, [healthCheckError]);

  return {
    healthCheck,
    healthCheckIsLoading,
    healthCheckError,
    retryHealthCheck,
    healthCheckCalled,
    healthCheckIsRetrying,
  };
}
